import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {GenericModal} from '@techsee/techsee-ui-common/lib/modals/generic';
import {LibraryDialogController} from './LibraryDialog.controller';
import {LibraryDialogHeader} from './components/LibraryDialogHeader';
import {LibraryDialogContent} from './components/LibraryDialogContent';
import {LibraryDialogToolbar} from './components/LibraryDialogToolbar';
import './LibraryDialog.scss';

interface LibraryDialogProps {
    ctrl: LibraryDialogController;
}

@observer
export class LibraryDialog extends TechseeBaseComponent<LibraryDialogProps> {
    renderHeader = (): JSX.Element => {
        const {ctrl} = this.props;
        return <LibraryDialogHeader ctrl={ctrl} />;
    };

    renderContent = (): JSX.Element => {
        const {ctrl} = this.props;
        return <LibraryDialogContent ctrl={ctrl} />;
    };

    renderToolbar = (): JSX.Element => {
        const {ctrl} = this.props;
        return <LibraryDialogToolbar ctrl={ctrl} />;
    };

    renderInternal(): JSX.Element {
        const {ctrl} = this.props;

        if (!ctrl.isVisible) {
            return <></>;
        }

        return (
            <GenericModal
                className='dashboard-library-modal new-top-bar'
                header={() => this.renderHeader()}
                content={() => this.renderContent()}
                toolbar={() => this.renderToolbar()}
                onHideHandler={ctrl.close}
                show={ctrl.isVisible}
                isCloseVisible={true}
            />
        );
    }
}
